module.exports = __webpack_public_path__ + "static/media/empty.3dcd56f4.png";